import type { Contact } from 'types'
import store from './store'

export const contacts = store<Contact[] | null>(null)
